import React from "react";
import TablaProveedor from "js/components/TablaProveedor";

export const Proveedor = props => {
  return <TablaProveedor />;
};

export default Proveedor;
